module.exports = __webpack_public_path__ + "static/media/User.ddf1fc7e.png";